import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { MoldType } from '../types/mold-type';
import { MoldLocation } from '../types/mold-location';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteMoldsService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/mold`;
  constructor(protected readonly http: HttpClient) {
    super();
  }

  moldTypes(): Observable<MoldType[]> {
    return this.http.get<MoldType[]>(`${this.urlRoute}/types`);
  }
  moldTypesByDepartment(department: string): Observable<MoldType[]> {
    return this.http.get<MoldType[]>(`${this.urlRoute}/types/` + department);
  }

  locationsByDepartment(department: string): Observable<MoldLocation[]> {
    return this.generalLocations(department);
  }

  locationsByMachine(machineId: number): Observable<MoldLocation[]> {
    return this.http.get<MoldLocation[]>(
      `${this.urlRoute}/${machineId}/locations-by-machine`
    );
  }

  generalLocations(department?: string): Observable<MoldLocation[]> {
    let params = new HttpParams();
    if (department) {
      params = params.append('department', department);
    }
    return this.http.get<MoldLocation[]>(`${this.urlRoute}/general-locations`, {
      params,
    });
  }
}
